var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column items-center"},[_c('q-spinner',{attrs:{"size":_vm.size,"color":"primary"}}),_c('span',{staticClass:"text-primary q-mt-sm",style:({
      fontSize: _vm.textSize,
    })},[_vm._v(" "+_vm._s(_vm.text)+"... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }